import { useQuery } from '@office-start/data-fetching';
import { useIdentity } from '@office-start/identity-service';
import { executeWebStorageGetUserItem } from '../operations/executeWebStorageGetUserItem';
import { getWebStorageKey } from '../util/getWebStorageKey';
export function useWebStorageGetUserItem(storageKey) {
    var identity = useIdentity().data;
    var queryKey = getWebStorageKey(storageKey);
    return useQuery(queryKey, function () { return executeWebStorageGetUserItem({ identity: identity, storageKey: storageKey }); }, {
        cacheTime: Infinity,
        staleTime: Infinity,
        enabled: !!identity,
    });
}
//# sourceMappingURL=useWebStorageGetUserItem.js.map